// ==================================================
//  Keyvisual
//   - ページ表示時にフワッと表示
// ==================================================
window.addEventListener("load", (event) => {
  const keyvisual = document.querySelector(".keyvisual-js");
  const keyvisualActiveClass = "keyvisual-js-active";

  setTimeout(() => {
    keyvisual.classList.add(keyvisualActiveClass);
  }, 300);
});

// ==================================================
//  もっとみる
// ==================================================
const descriptionMore = document.querySelector(".description_more-js");
const descriptionMoreActiveClass = "description_more-js-active";
const descriptionMoreButton = document.querySelector(".description_moreButton-js");
const descriptionMoreButtonActiveClass = "description_moreButton-js-active";

descriptionMoreButton.addEventListener("click", (event) => {
  descriptionMoreButton.classList.add(descriptionMoreButtonActiveClass);
  descriptionMore.classList.add(descriptionMoreActiveClass);
});

// ==================================================
//  季節画像
// ==================================================
const voiceBg = document.querySelector(".voiceBg-js");
function seasonCheck() {
  const month = new Date().getMonth() + 1;
  let classNameStr = "";

  // 条件
  if (month >= 3 && month <= 4) {
    classNameStr = "spring";
  } else if (month >= 5 && month <= 8) {
    classNameStr = "summer";
  } else if (month >= 9 && month <= 11) {
    classNameStr = "autumn";
  } else {
    classNameStr = "winter";
  }

  voiceBg.classList.add("voiceBg-" + classNameStr);
}
seasonCheck();

// ==================================================
//  Tanzaku
//   - モーダル
// ==================================================
MicroModal.init({
  awaitOpenAnimation: true,
  awaitCloseAnimation: true,
});
const tanzaku = document.querySelectorAll(".tanzaku-js");
let tanzakuPrint = document.getElementById("tanzakuPrint");
for (let i = 0; i < tanzaku.length; i++) {
  tanzaku[i].addEventListener("click", (e) => {
    e.preventDefault();

    const tanzakuSrc = tanzaku[i].getAttribute("data-src");
    tanzakuPrint.src = tanzakuSrc;
    MicroModal.show("modal-tanzaku");
  });
}
